import { useContext } from 'react'

import { AuthContext } from './AuthContext'
import { type AuthState } from './AuthState'

export const useAuth = (): AuthState => {
  const context = useContext(AuthContext)

  if (!context) {
    console.warn(
      'AuthProvider context is undefined, please verify you are calling useAuth() as child of a <AuthProvider> component.',
    )
  }

  return context as AuthState
}
